/* eslint-disable import/no-anonymous-default-export */
import LoanCardReportActionTypes from './loan-card-report.types';
import { docodeHexResponse } from '../../_common/common.utils';
const INITIAL_STATE = {
	getLoanCardReportResponse: null,
	getLoanCardReportArr: [],

	getMemberLoanCardResponse: null,
	getMemberLoanCardArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/****************  GET PARTICULAR MEMBER LOAN CARD START ********************** */
		case LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_SUCCESS:
			return {
				...state,
				getMemberLoanCardResponse: action.payload,
				getMemberLoanCardArr: docodeHexResponse(
					action.payload,
					'GetLoanDetailsForParticularMemberKey',
				),
			};

		case LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_FAILURE:
			return { ...state, getMemberLoanCardResponse: action.payload };

		case LoanCardReportActionTypes.GET_MEMBER_LOAN_CARD_RESPONSE_CHANGED:
			return { ...state, getMemberLoanCardResponse: null };
		/****************  GET PARTICULAR MEMBER LOAN CARD END ********************** */

		default:
			return state;
	}
};
